import { render } from "./ProformaEditar.vue?vue&type=template&id=2193bc6e&scoped=true"
import script from "./ProformaEditar.vue?vue&type=script&lang=js"
export * from "./ProformaEditar.vue?vue&type=script&lang=js"

import "./ProformaEditar.vue?vue&type=style&index=0&id=2193bc6e&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2193bc6e"]])

export default __exports__